import { render } from "./CategoryTwelve.vue?vue&type=template&id=3a3f8de0"
import script from "./CategoryTwelve.vue?vue&type=script&lang=ts"
export * from "./CategoryTwelve.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QPage from 'quasar/src/components/page/QPage.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage});
